// The moment locale does not get set as i18n does and so we are doing it here.
moment.locale(EG.currentLocale);